import { render, staticRenderFns } from "./ProductSalesPageResults.vue?vue&type=template&id=00772d46&scoped=true&"
import script from "./ProductSalesPageResults.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00772d46",
  null
  
)

export default component.exports